import { DmTaiLieuModel } from './../models/dmtailieu.model';
import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from './config.service';
import { NhanVienModel, NhanVienSearch } from './../models/nhanvien.model';
import { ResponseData, PagedList } from './../models/model';
import { catchError } from 'rxjs/operators';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DmTaiLieuService extends BaseService{
  private baseUrl;
  constructor(private http: HttpClient, private configService: ConfigService) {
    super();
    this.baseUrl = configService.getBaseUrl();
  }

  create(model: any): Observable<any> {
    const headers = this.getHeaders(true);
    return this.http.post<any>(this.baseUrl + this.configService.url.dmTaiLieu.create, model, { headers })
      .pipe(catchError(this.handleError('createDmTaiLieu', new ResponseData<any>())));
  }

  update(model: any): Observable<any> {
    const headers = this.getHeaders(true);
    return this.http.post<any>(this.baseUrl + this.configService.url.dmTaiLieu.update, model, { headers });
  }

  delete(id: number): Observable<ResponseData<any>> {
    const headers = this.getHeaders(true);
    return this.http.delete<ResponseData<any>>(this.baseUrl + this.configService.url.dmTaiLieu.delete + '/' + id, { headers })
      .pipe(catchError(this.handleError('deleteDmTaiLieu', new ResponseData<any>())));
  }

  upload(dmTaiLieuModel: DmTaiLieuModel): Observable<any> {
    const formData = new FormData();
    var model = new DmTaiLieuModel();
    formData.append('model', JSON.stringify(model));
    return this.http.post<any>(this.baseUrl + this.configService.url.nhanvien.upload, formData, { observe: 'response' });
  }

  download(fileUrl: string): Observable<any>{
    return this.http.post(this.baseUrl + this.configService.url.dmTaiLieu.download, fileUrl, { observe: 'response', responseType: 'arraybuffer' });
  }

}
